import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteColumnn } from 'api/dashboards/addColumn'
import { AxiosError } from 'axios'
import { ErrorResponse } from 'shared/types'

export const useDeleteColumn = ({
  rowId,
  columnId,
}: {
  rowId: string
  columnId: string
}) => {
  const queryClient = useQueryClient()
  const onError = (error: AxiosError<ErrorResponse>) => {
    if (error.response?.data.errors) {
      showNotification({
        color: 'red',
        message: error.response.data.errors
          .map(error => error.message)
          .join(', '),
      })
      return
    }
    showNotification({
      color: 'red',
      message: 'An error occured while adding new column',
    })
  }

  const mutation = useMutation({
    mutationFn: deleteColumnn({ rowId, columnId }),

    onSuccess: () => {
      queryClient.refetchQueries('dashboards' as unknown as readonly unknown[])
    },
    onError,
  })

  return mutation
}
